// extracted by mini-css-extract-plugin
export default {"videoPoster":"vX8_AH"};